<p-dialog [style]="{ width: '50vw' }" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [header]="title"
  [modal]="isModal" [draggable]="isDraggable" [resizable]="isResizable" [(visible)]="display"
  (onHide)="closeDialog(false)">
  <div class="content-container">
    <ng-content></ng-content>
  </div>
  <ng-template #footer>
    <p-button label="No" (click)="closeDialog(false)" />
    <p-button label="Yes" [disabled]="confirmDisabled" (click)="closeDialog(true)" />
  </ng-template>
</p-dialog>